/**
 * Gift Card form on Checkout page (VueJS)
 * Adds events to handle gift card submissions by the form injected into the VueJS app.
 *
 * Notes:
 * It's very difficult to provide feedback to the user because the plugin always return a rendered html
 * string with a refresh of the default WooCommerce checkout page, which we don't use since our checkout
 * is a VueJS app. So instead of looking for hints on the returned html string, we do nothing.
 * After each form submission the checkout is refreshed and if any gift cards were applied, that will
 * be shown in the sidebar summary, but that's it.
 */
const GiftCardEvents = {

  init() {
    this.addSubmitFormEvents();
  },

  /**
   * We grabbed the original events from the plugin and modified it accordingly.
   * Look in the original file for other events that you might need in the future.
   *
   * Taken from:
   * woocommerce-gift-cards/assets/js/front-end/wc-gc-main.js
   */
  addSubmitFormEvents() {
    window.jQuery( '#wc_gc_cart_redeem_send' ).on( 'click', function( e ) {
      e.preventDefault();

      var code = window.jQuery( '#wc_gc_cart_code' ).val();

      if ( ! code ) {
        return;
      }

      const $giftCardForm = window.jQuery( 'div.add_gift_card_form' );
      $giftCardForm.block({ message: null, overlayCSS: { background: '#fff', opacity: 0.6 } });

      window.jQuery.ajax({
        type:     'post',
        url:      GiftCardEvents.getUrl( 'apply_gift_card_to_session' ),
        data:     'wc_gc_cart_code=' + code + '&security=' + window.wc_gc_params.security_redeem_card_nonce,
        dataType: 'html',
        complete: function() {
          // Resets form and collapses it
          window.jQuery( '#wc_gc_cart_code' ).val('');
          window.jQuery( '#wc_gc_cart_code' )
            .closest('.js-coupon')
            .find('.js-coupon-accordion-trigger')
            .trigger('click')
          ;

          $giftCardForm.unblock();

          // Refreshes checkout so we can see any gift cards that are applied
          window.jQuery(document.body).trigger('updated_checkout');
        }
      });

      return false;
    });
  },

  /**
   * Gets a url for a given AJAX endpoint.
   *
   * @param {String} endpoint The AJAX Endpoint
   * @return {String} The URL to use for the request
   */
  getUrl(endpoint) {
    return wc_gc_params.wc_ajax_url.toString().replace(
      '%%endpoint%%',
      endpoint
    );
  }
};

export default GiftCardEvents;